export const SOMETHING_WENT_WRONG = "Something went wrong!";
